<template>
    <v-container>
        <v-row>
            <v-col>
                <div class="text-h5">Filer</div>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card outlined>
                    <v-card-title>
                        <div class="d-flex align-center">
                            <div class="text-h6">Riggplaner</div>
                            <v-btn @click="triggerInput('siteplanInput', 'siteplans')" class="ma-1" x-small fab elevation="0">
                                <v-icon color="success">mdi-plus</v-icon>
                            </v-btn>
                            <input ref="siteplanInput" @change="inputChange" type="file" :accept="contentTypes" hidden="true">
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table @click:row="showContent" :items="siteplans" :headers="headers" class="text-no-wrap row-pointer" :mobile-breakpoint="0" hide-default-footer disable-pagination>
                            <template v-slot:item.name="{item}">
                                <div>
                                    {{/.*\/(.*)/.exec(item.name)[1]}}
                                </div>
                            </template>
                            <template v-slot:item.actions="{item}">
                                <div>
                                    <v-btn @click.stop="deleteContent(item)" x-small fab elevation="0">
                                        <v-icon color="error">mdi-delete</v-icon>
                                    </v-btn>
                                </div>
                            </template>
                            <template v-slot:no-data>
                                Ingen riggplaner
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card outlined>
                    <v-card-title>
                        <div class="d-flex align-center">
                            <div>Veibreskrivelser</div>
                            <v-btn @click="() => { triggerInput('siteplanInput', 'directions') }" class="ma-1" x-small fab elevation="0">
                                <v-icon color="success">mdi-plus</v-icon>
                            </v-btn>
                            <!-- <input ref="siteplanInput" @change="inputChange" type="file" accept="image/png, image/jpeg, .pdf" hidden="true"> -->
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table @click:row="showContent" :items="directions" :headers="headers" class="text-no-wrap row-pointer" :mobile-breakpoint="0" hide-default-footer disable-pagination>
                            <template v-slot:item.name="{item}">
                                <div>
                                    {{/.*\/(.*)/.exec(item.name)[1]}}
                                </div>
                            </template>
                            <template v-slot:item.actions="{item}">
                                <div>
                                    <v-btn @click.stop="deleteContent(item)" x-small fab elevation="0">
                                        <v-icon color="error">mdi-delete</v-icon>
                                    </v-btn>
                                </div>
                            </template>
                            <template v-slot:no-data>
                                Ingen veibeskrivelser
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>

                <!-- <v-card outlined>
                    <v-card-title>
                        <div class="d-flex align-center">
                            <div>Veibreskrivelser</div>
                            <v-btn class="ma-1" x-small fab elevation="0">
                                <v-icon color="success">mdi-plus</v-icon>
                            </v-btn>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table :items="directions" :headers="headers" class="text-no-wrap" :mobile-breakpoint="0" hide-default-footer disable-pagination>
                            <template v-slot:item.name="{item}">
                                <div>
                                    {{/.*\/(.*)/.exec(item.name)[1]}}
                                </div>
                            </template>
                            <template v-slot:no-data>
                                Ingen veibeskrivelser
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card> -->
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card outlined>
                    <v-card-title>
                        <div class="d-flex align-center">
                            <div>Dokumenter</div>
                            <v-btn @click="() => { triggerInput('siteplanInput', 'documents') }" class="ma-1" x-small fab elevation="0">
                                <v-icon color="success">mdi-plus</v-icon>
                            </v-btn>
                            <!-- <input ref="siteplanInput" @change="inputChange" type="file" accept="image/png, image/jpeg, .pdf" hidden="true"> -->
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table @click:row="showContent" :items="documents" :headers="headers" class="text-no-wrap row-pointer" :mobile-breakpoint="0" hide-default-footer disable-pagination>
                            <template v-slot:item.name="{item}">
                                <div>
                                    {{/.*\/(.*)/.exec(item.name)[1]}}
                                </div>
                            </template>
                            <template v-slot:item.actions="{item}">
                                <div>
                                    <v-btn @click.stop="deleteContent(item)" x-small fab elevation="0">
                                        <v-icon color="error">mdi-delete</v-icon>
                                    </v-btn>
                                </div>
                            </template>
                            <template v-slot:no-data>
                                Ingen dokumenter
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="contentShow" @keydown.esc="() => {contentShow = false; contentFullscreen = false;}">
            <div v-if="content && content.name" style="max-height: 90vmin; background: white; position: relative;">
                <div style="position: absolute; top: 40px; left: 10px; background: rgba(255,255,255,0.65); z-index: 10;" class="ma-2 pa-2 text-h6">{{/.*\/.*\/(.*)/.exec(content.name)[1]}}</div>
                <div style="position: absolute; top: 40px; right: 30px; z-index: 10; display: flex; flex-direcion: row;">
                    <v-btn v-if="isImage(content)" fab small color="rgba(255,255,255,0.65)" style="position: sticky;" @click="() => {contentFullscreen = !contentFullscreen;}">
                        <v-icon v-if="contentFullscreen">mdi-fullscreen-exit</v-icon>
                        <v-icon v-else>mdi-fullscreen</v-icon>
                    </v-btn>
                    <div v-if="isImage(content)" class="mx-1"></div>
                    <v-btn fab small color="rgba(255,255,255,0.65)" style="position: sticky;" @click="() => { contentShow = false; contentFullscreen = false;}">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>

                <v-img v-if="!contentFullscreen && isImage(content)" :src="content.src" class="ma-auto" max-height="90vmin" max-width="90vmin" :contain="!contentFullscreen"></v-img>
                <v-img v-if="contentFullscreen && isImage(content)" :src="content.src" class="ma-auto"></v-img>
                <div v-if="isPdf(content)" class="d-flex align-stretch" style="background: grey; height: 80vmin; width: -webkit-fill-available;">
                    <iframe :src="`${content.url}#view=fit`" allowfullscreen="false" width="100%" height="100%" style="width: -webkit-fill-available; padding: 0px; margin: 0px; border: none;"></iframe>
                </div>

            </div>
        </v-dialog>

        <v-overlay v-model="contentLoading">
            <v-progress-circular indeterminate></v-progress-circular>
        </v-overlay>
    </v-container>
</template>

<script>
// import * as axios from "axios";
export default {
    data() {
        return {
            // files: [],
            headers: [
                { text: "Navn", value: "name", width:"50%"},
                // { text: "Type", value: "metadata.contentType", width:"30%"},
                { text: "Størrelse (B)", value: "size", width:"20%"},
                { text: "Handlinger", value: "actions", width:"20%"}
            ],
            content: {
                src: undefined,
            },
            contentLoading: false,
            contentShow: false,
            contentType: undefined,
            acceptedContentTypes: [],
            contentFullscreen: false,
            contentDisplay: "d-flex"
        }
    },
    computed: {
        files() {
            return this.$store.getters.files;
        },
        siteplans() {
            return this.$store.getters.filesByType("siteplans");
        },
        directions() {
            return this.$store.getters.filesByType("directions");
        },
        documents() {
            return this.$store.getters.filesByType("documents");
        },
        contentTypes() {
            return this.acceptedContentTypes.join(",");
        },
        contentContain() {
            return !this.contentFullscreen;
        }
    },
    watch: {
        contentFullscreen(value) {
            value ? this.contentDisplay = "d-block" : this.contentDisplay = "d-flex";
        }
    },
    methods: {
        async listFiles() {
            let files = await this.$store.dispatch("listFiles");
            files.forEach(file => {
                this.$store.dispatch("addFile", file);
            });
        },
        triggerInput(id, type) {
            this.contentType = type;

            switch (type) {
                case "siteplans":
                case "directions":{
                    this.acceptedContentTypes.push("image/jpeg");
                    this.acceptedContentTypes.push("image/png");
                    break;}
                case "documents":{
                    this.acceptedContentTypes.push("image/jpeg");
                    this.acceptedContentTypes.push("image/png");
                    this.acceptedContentTypes.push("application/pdf");
                    break;}
            }

            setTimeout(() => {
                let input = this.$refs[id];
                input.click();
            }, 50);
        },
        async inputChange(e) {
            this.contentLoading = true;
            try {
                let file = e.target.files[0];
                if(!file) {
                    throw new Error("Upload file missing.")
                }

                if(!this.acceptedContentTypes.includes(file.type)){
                    throw new Error(`File type ${file.type} not supported.`);
                }

                let {fileName,fileSize} = await this.$store.dispatch("uploadFile", {file:file, fileType:this.contentType});
                this.$store.commit("addFile", {name: fileName, size: fileSize});
            }
            catch(err) {
                this.$store.dispatch("snackbar", { show: true, text: `Opplasting mislyktes. ${err}`, color:"error"})
            }
            finally {
                e.target.value = "";
                this.contentLoading = false;
                this.contentType = undefined;
            }
        },
        async showContent(file){
            if(file.src && file.src.length > 0){
                this.$set(this, "content", file);
                this.contentShow = true;
                return;
            }

            // this sets binary, buffer, src, blob and url
            await this.downloadContent(file);

            this.$set(this, "content", file);
            this.contentShow = true;
        },
        hideContent(){
            this.contentShow = false;
            this.contentFullscreen = false;
        },
        async downloadContent(file) {
            this.contentLoading = true;
            try {
                // file -> {name, size, binary, buffer, src, blob, url}
                let {binary,buffer,src,blob,url} = await this.$store.dispatch("downloadFile", file.name);

                this.$set(file, "binary", binary);
                this.$set(file, "buffer", buffer);
                this.$set(file, "src", src);
                this.$set(file, "blob", blob);
                this.$set(file, "url", url);
            } catch (error) {
                this.$store.dispatch("snackbar", { show: true, text: `Nedlasting mislyktes. ${error}`, color:"error"})
            } finally {
                this.contentLoading = false;
            }
        },
        isImage(content){
            // return content && content.name && (content.name.toLowerCase().includes('.jpg') || content.name.toLowerCase().includes('.png'))
            if(!content || !content.name) return false;

            return content?.name.toLowerCase().includes('.jpg') || content?.name.toLowerCase().includes('.jpeg') || content?.name.toLowerCase().includes('.png');
        },
        isPdf(content){
            // return content && content.name && (content.name.toLowerCase().includes('.jpg') || content.name.toLowerCase().includes('.png'))
            if(!content || !content.name) return false;

            return content?.name.toLowerCase().includes('.pdf');
        },
        async deleteContent(content) {
            this.contentLoading = true;
            try {
                await this.$store.dispatch("deleteFile", content);
                this.$store.commit("removeFile", content);
            } catch (error) {
                this.$store.dispatch("snackbar", { show: true, text: `Sletting mislyktes. ${error}`, color:"error"});
            } finally {
                this.contentLoading = false;
            }
        }
    },
    mounted() {
        this.listFiles();
    },
    beforeRouteEnter(to, from, next) {
        next(vue => {
            vue.$store.commit("showAppBar", true);
            vue.$store.commit("showNavDrawer", true);
        });
    },
}
</script>

<style scoped>
    .row-pointer >>> tbody tr :hover{
        cursor: pointer;
    }
</style>